import { useContext } from 'react'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import PageContext from '@contexts/pageContext'

import useBrandGroupProvider from '@hooks/useBrandGroupProvider'
import { generateUrls } from '@hooks/useProvider'

import type { BrandGroupProviderModel } from '@models/types'

const confirmDelete = (deleteBrandGroupProvider: () => Promise<object>, deleteFn: () => void) => {
  const deleteBrandGroupProviderPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Provider Removed',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Provider?',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2554
        deleteBrandGroupProvider(deleteBrandGroupProviderPayload)
      }
    })
}

const BrandGroupProviderListItem = (props: { brandGroupProvider: BrandGroupProviderModel}) => {
  const { brandGroupProvider: initBrandGroupProvider } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: { deleteBrandGroupProvider },
  } = pageContext

  const {
    brandGroupProvider: {
      identity_code,
    },
    callbacks: {
      deleteBrandGroupProvider: deleteFn,
    },
    provider,
  } = useBrandGroupProvider(initBrandGroupProvider)

  const { title: providerTitle } = provider

  const { editProviderUrl } = generateUrls({ id: provider.id })

  return (
    <DashboardModuleListItem
      secondaryText={identity_code}
      title={providerTitle}
    >

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteBrandGroupProvider, deleteFn)}
          type="delete"
        />

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
        </ScopedConditionalContent>
        {/*
        // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandGroupProviderListItem
